import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useApp } from '../AppContext';
import MenuCard from '../components/MenuCard';
import LanguageSwitcher from '../components/LanguageSwitcher';
import Logo from '../components/Logo';
import { tr } from '../i18n';
import { ArrowLeft } from 'lucide-react';
import { resolveImg, thumbImg } from '../utils/resolveImg';

const Category = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { menu, lang, t } = useApp();
  const subs = (menu.subCategories && menu.subCategories[slug]) || [];
  const main = menu.mainCategories.find((c) => c.slug === slug);

  if (!main) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <p className="font-display text-3xl mb-4">{t('categoriaNon')}</p>
          <button className="pill-btn" onClick={() => navigate('/')}>{t('tornaMenu')}</button>
        </div>
      </div>
    );
  }

  return (
    <div className="relative min-h-screen w-full pt-6 pb-24 px-4 md:px-10">
      <div className="relative max-w-6xl mx-auto">
        <div className="flex items-center justify-between gap-2 mb-10">
          <button
            onClick={() => navigate('/')}
            data-testid="category-back-btn"
            className="w-11 h-11 flex-shrink-0 rounded-full border-[1.5px] border-black flex items-center justify-center hover:bg-black hover:text-white transition"
            aria-label={t('back')}
          >
            <ArrowLeft size={16} />
          </button>
          <Logo height={40} linkHome />
          <LanguageSwitcher />
        </div>

        <div className="text-center py-6">
          <p className="text-xs font-bold uppercase tracking-[0.32em] text-black/60 mb-3">{lang === 'it' ? 'Categoria' : 'Category'}</p>
          <h1 className="font-display text-[54px] md:text-[92px] leading-[0.9] text-black">
            {tr(main.name, lang)}
          </h1>
          <p className="mt-3 text-black/70 text-base md:text-lg">{tr(main.subtitle, lang)}</p>
          <div className="mt-5 hairline w-12 mx-auto" />
        </div>

        <div className="mt-8 grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-7">
          {subs.map((sub, idx) => (
            <div key={sub.slug} className="float-in" style={{ animationDelay: `${idx * 80}ms` }}>
              <MenuCard
                image={thumbImg(sub.image, 640)}
                fallback={resolveImg(sub.image)}
                label={tr(sub.name, lang)}
                onClick={() => navigate(`/categoria/${slug}/${sub.slug}`)}
                buttonLabel={t('seleziona')}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Category;
